/* eslint-disable react/prop-types */
import { AuthorizedRoute } from '@tshio/react-router-permissions';
import { Redirect } from 'react-router-dom';
import React from 'react';
import { Role } from 'api/types/auth';

export const OverviewRoute = ({ children, ...rest }) => {
  return (
    <AuthorizedRoute requires={[Role.HOST]} {...rest}>
      {({ isAuthorized }) =>
        isAuthorized ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login/',
              state: {
                next: '/overview/',
                redirectReason: 'You have to login as a Host to be able to access this page.',
              },
            }}
          />
        )
      }
    </AuthorizedRoute>
  );
};
